import { useQuery } from 'react-query';

import { api_suggested_ai_prompts_path } from '@routes';
import request from '@utils/backend-api/request';

export const AI_THREADS_KEY = 'AI_THREADS';
export const SUGGESTED_AI_PROMPTS_KEY = 'SUGGESTED_AI_PROMPTS';

export function useSuggestedAiPrompts() {
  const { data, isLoading } = useQuery(SUGGESTED_AI_PROMPTS_KEY, async () => {
    return await request('get', api_suggested_ai_prompts_path());
  });

  return {
    suggestedAiPrompts: data?.suggestedAiPrompts || [],
    isLoadingSuggestedAiPrompts: isLoading,
  };
}
